import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Index from './Components/Login/index'
import ViewProfile from './Components/Login/ViewProfile'
import FormularioCadastro from './pages/FormularioCadastro'
import Home from './pages/Home'
import ListagemHome from './pages/ListagemHome'
import ListagemChecklist from './pages/ListagemChecklist'
import ListagemChecklistRel from './pages/Relatorio/ListagemChecklist'
import Documentos from './pages/MenuDireito/Documentos'
import DocumentosLocais from './pages/MenuDireito/DocumentosLocais'
import RelatorioAuditoria from './pages/MenuDireito/RelatorioAuditoria'
import RelatorioAudit from './pages/MenuDireito/RelatórioAudit'
import Restaurantes from './pages/MenuDireito/Restaurantes'
import Texto from './pages/MenuDireito/Texto'
import Unidades from './pages/MenuDireito/Unidades'
import Pessoas from './pages/Pessoas'
import ListagemRelatorio from './pages/Relatorio/ListagemRelatorio'
import Relatorio from './pages/Relatorio/Relatorio'
import RelatorioLocal from './pages/Relatorio/RelatorioLocal'
import SubMenuClassificao from './pages/SubMenuPages/SubMenuClassificacao/SubMenuClassificacoes'
import SubMenuFuncaoEPermissao from './pages/SubMenuPages/SubMenuFuncoesEPermissoes/SubMenuFuncoesEPermissoes'
import PermissoesDeacessoAoSistema from './pages/SubMenuPages/SubMenuGruposDeUsuario/pages-GruposDeUsuario/PermissoesDeAcessoAoSistema'
import SubMenuGruposUsuarios from './pages/SubMenuPages/SubMenuGruposDeUsuario/SubMenuGruposUsuarios'
import SubMenuPessoas from './pages/SubMenuPages/SubMenuPessoas/SubMenuPessoas'
import VinculoUnidade from './pages/SubMenuPages/SubMenuPessoas/VinculoUnidade'
import SubMenuTipoDocumento from './pages/SubMenuPages/SubMenuTipoDocumento/SubMenuTipoDocumento'
import Checklist from './pages/SubMenuPages/SubMenuTiposDeobservacoes/Checklist'
import ChecklistEstrutura from './pages/SubMenuPages/SubMenuTiposDeobservacoes/ChecklistEstrutura'
import ChecklistGrupoQuestoes from './pages/SubMenuPages/SubMenuTiposDeobservacoes/ChecklistGrupoQuestoes'
import ChecklistQuestoesSubGrupo from './pages/SubMenuPages/SubMenuTiposDeobservacoes/ChecklistSubGrupoQuestoes'
import ChecklistQuestoes from './pages/SubMenuPages/SubMenuTiposDeobservacoes/ChecklistQuestoes'

 

//import Checklist from './pages/SubMenuPages/SubMenuTiposDeobservacoes/Checklist'

function _Routes() {
  //localStorage.clear()
  const permissoes = localStorage.getItem('permissoes')
  let permissao = []
  if (permissoes) {
    permissao = JSON.parse(permissoes)
  } else {
    permissao = [
      {
        perModulo: 'ACECAD',
        perAcesso: 1
      },
      {
        perModulo: 'ACELOC',
        perAcesso: 1
      },
      {
        perModulo: 'ACEPES',
        perAcesso: 1
      },
      {
        perModulo: 'ACEAUD',
        perAcesso: 1
      },
      {
        perModulo: 'ACETXT',
        perAcesso: 1
      },
      {
        perModulo: 'ACEUNI',
        perAcesso: 1
      },
      {
        perModulo: 'ACEGPU',
        perAcesso: 1
      },
      {
        perModulo: 'ACEFUN',
        perAcesso: 1
      },
      {
        perModulo: 'ACEREL',
        perAcesso: 1
      },
      {
        perModulo: 'ACETPD',
        perAcesso: 1
      },
      {
        perModulo: 'ACEDOC',
        perAcesso: 1
      }
    ]
  }
  let ACECAD = permissao.find((element: any) => {
    return element.perModulo === 'ACECAD'
  })
  let ACELOC = permissao.find((element: any) => {
    return element.perModulo === 'ACELOC'
  })
  let ACEPES = permissao.find((element: any) => {
    return element.perModulo === 'ACEPES'
  })
  let ACEAUD = permissao.find((element: any) => {
    return element.perModulo === 'ACEAUD'
  })
  let ACETXT = permissao.find((element: any) => {
    return element.perModulo === 'ACETXT'
  })
  let ACEUNI = permissao.find((element: any) => {
    return element.perModulo === 'ACEUNI'
  })
  let ACEGPU = permissao.find((element: any) => {
    return element.perModulo === 'ACEGPU'
  })
  let ACEFUN = permissao.find((element: any) => {
    return element.perModulo === 'ACEFUN'
  })
  let ACEREL = permissao.find((element: any) => {
    return element.perModulo === 'ACEREL'
  })
  let ACETPD = permissao.find((element: any) => {
    return element.perModulo === 'ACETPD'
  })
  let ACEDOC = permissao.find((element: any) => {
    return element.perModulo === 'ACEDOC'
  })
  return (
    <Routes>

    {/*--------------acesso do sub Menu (tipo de observaçao)-------------*/}
      <Route
          path="/Checklist"
          element={<Checklist />}
          ></Route>

      <Route 
          path="/checklistEstrutura/:IdObservacaoTipo"
          element={<ChecklistEstrutura />}
          ></Route>
      <Route
          path="/SubMenuTipoDeObservacao"
          element={<Checklist />}
        ></Route>

      <Route
          path="/ChecklistGrupoQuestoes/:IdObservacaoTipo"
          element={<ChecklistGrupoQuestoes />}
        ></Route>

      <Route
          path="/ChecklistQuestoesSubGrupo/:IdObservacaoGrupo"
          element={<ChecklistQuestoesSubGrupo />}
        ></Route>

      <Route
          path="/ChecklistQuestoes/:IdObservacaoSubGrupo"
          element={<ChecklistQuestoes />}
        ></Route>


      <Route path="/" element={<Index />} />
      <Route path="/ViewProfile" element={<ViewProfile />}></Route>
      {/* ------------ menu princial ----------------------------*/}
      {/*ACEREL.perAcesso && <Route path="/Home" component={Home} />*/}
      <Route path="/Home" element={<Home />} />
      {/* {ACEAUD.perAcesso && (
        <Route path="/Relatorio" component={Relatorio}></Route>
      )} */}
      <Route path="/Relatorio" element={<Relatorio />}></Route>
      {ACEREL.perAcesso && (
        <Route
          path="/RelatorioLocal/:IdLocal"
          element={<RelatorioLocal />}
        ></Route>
      )}
      {ACEREL.perAcesso && (
        <Route path="/ListagemRelatorio" element={<ListagemRelatorio />}></Route>
      )}
      {ACEREL.perAcesso && (
        <Route path="/ListagemHome" element={<ListagemHome />}></Route>
      )}
      {ACEREL.perAcesso && (
        <Route path="/ListagemChecklist" element={<ListagemChecklist />}></Route>
      )}
      {ACEREL.perAcesso && (
        <Route path="/ListagemChecklistRel" element={<ListagemChecklistRel />}></Route>
      )}
      {ACEREL.perAcesso && (
        <Route
          path="/RelatorioAudit/:IdRetornoAuditoria"
          element={<RelatorioAudit />}
        ></Route>
      )}
      {ACECAD.perAcesso && (
        <Route path="/FormularioCadastro" element={<FormularioCadastro />} />
      )}
      {/* {ACEPES.perAcesso && <Route path="/Pessoas" component={Pessoas} />} */}
      <Route path="/Pessoas" element={<Pessoas />} />

      {/* ------------ menu sideBar direita---------------------- */}
      {/* <Route path="/Observacoes" component={Observacoes} />
      <Route path="/Equipes" component={Equipes} />
      <Route path="/Gerencias" component={Gerencias}></Route> */}
      {/* {ACEUNI.perAcesso && ( */}
        <Route path="/Unidades" element={<Unidades />}></Route>
      {/* )} */}
      {ACETXT.perAcesso && <Route path="/Texto" element={<Texto />}></Route>}
      {ACETXT.perAcesso && (
        <Route path="/Classificacao" element={<SubMenuClassificao />}></Route>
      )}
      {/* <Route path="/Area" component={Area}></Route> */}
      {/* <Route path="/Atividades" component={Atividades}></Route> */}
      {ACELOC.perAcesso && (
        <Route path="/Locais" element={<Restaurantes />}></Route>
      )}

      {/* -------- relaçao de paginas da tela relatório ------------*/}
      {/* <Route path="/UniClienteExe" component={UniClienteExe}></Route>
      <Route path="/UniClieSetor" component={UniClieSetor}></Route>
      <Route path="/MesSetor" component={MesSetor}></Route>
      <Route path="/UniContribSetor" component={UniContribSetor}></Route>
      <Route path="/ObservCpto" component={ObservCpto}></Route> */}

      {/* -------- relaçao de paginas do apontamento de observação ------------*/}
      {/* <Route
        path="/ApontarObservacao/SelecionarUnidade"
        component={SelecionarUnidade}
      ></Route>
      <Route
        path="/ApontarObservacao/SelecionarArea/:id"
        component={SelecionarArea}
      ></Route>
      <Route
        path="/ApontarObservacao/PreenchimentoObservacao/:idUni/:idAr"
        component={PreenchimentoObservacao}
      ></Route>

      <Route
        path="/Planejamento/:idUni/:idAr/:idObs"
        component={Planejamento}
      ></Route> */}

      {/* ---------------- SUB MENU Gerencia----------------- */}
      {/* <Route path="/SubMenuTextActive" component={SubMenuTextActive}></Route> */}
      {ACEPES.perAcesso && (
        <Route path="/SubMenuPessoas" element={<SubMenuPessoas />}></Route>
      )}
      {ACEPES.perAcesso && (
        <Route
          path="/VinculoUnidade/:IdPessoa"
          element={<VinculoUnidade />}
        ></Route>
      )}
      {/*        
      <Route path="/SubMenuEmpresas" component={SubMenuEmpresas}></Route>
      <Route
        path="/SubMenuTipoDeObservacao"
        component={SubMenuTipoDeObservacao}
      ></Route> */}
      {ACEGPU.perAcesso && (
        <Route
          path="/SubMenuGruposUsuarios"
          element={<SubMenuGruposUsuarios />}
        ></Route>
      )}
      {ACEFUN.perAcesso && (
        <Route
          path="/SubMenuFuncaoEPermissao"
          element={<SubMenuFuncaoEPermissao />}
        ></Route>
      )}

      
      
      {ACEGPU.perAcesso && (
        <Route
          path="/PermissoesDeacessoAoSistema/:IdGrupoUsuario"
          element={<PermissoesDeacessoAoSistema />}
        ></Route>
      )}
      {/* <Route path="/Ativadores" component={Ativadores}></Route> */}
      {ACEDOC.perAcesso && <Route path="/Documentos" element={<Documentos />} />}
      {ACETPD.perAcesso && (
        <Route path="/SubMenuTipoDocumento" element={<SubMenuTipoDocumento />} />
      )}
      {ACEDOC.perAcesso && (
        <Route path="/DocumentosLocais/:IdLocal" element={<DocumentosLocais />} />
      )}
      <Route
        path="/RelatorioAuditoria/:IdRetornoAuditoria"
        element={<RelatorioAuditoria />} />
    </Routes>
  )
}

export default _Routes
